import React,{Component} from 'react';


class InventoryDisplayProduct2 extends Component{
    	
       
    render() {
        
        return (
                <tr>
                    
                    <td>
                        <p>{this.props.product.product_name}</p>
                    </td>
                    <td>
                        <p>Pcs</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_length}</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_color}</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_count}</p>
                    </td>
                          
                  
                </tr>
	    
        );
    }
}

export default  InventoryDisplayProduct2;


// WEBPACK FOOTER //
// ./src/components/InventoryDisplayProduct2.js